// eslint-disable-next-line import/prefer-default-export
export const recommendedTripsTypes = {
  generalRecommendations: { concept: 'frequent' },
  byPreferenceItinerary: { concept: 'frequent' },
  byPreferenceTickets: { concept: 'frequent' },
  byPrice: { concept: 'affordable' },
  byDuration: { concept: 'fast' },
  byPopularity: { concept: 'popular' },
};
